import Audio from './loader/Audio';
import BallTriangle from './loader/BallTriangle';
import Bars from './loader/Bars';
import Circles from './loader/Circles';
import CirclesWithBar from './loader/CirclesWithBar';
import CradleLoader from './loader/CradleLoader';
import Grid from './loader/Grid';
import Hearts from './loader/Hearts';
import LineWave from './loader/LineWave';
import MutatingDots from './loader/MutatingDots';
import Oval from './loader/Oval';
import Plane from './loader/Plane';
import Puff from './loader/Puff';
import RevolvingDot from './loader/RevolvingDot';
import Rings from './loader/Rings';
import RotatingSquare from './loader/RotatingSquare';
import TailSpin from './loader/TailSpin';
import ThreeCircles from './loader/ThreeCircles';
import ThreeDots from './loader/ThreeDots';
import Triangle from './loader/Triangle';
import Watch from './loader/Watch';
export { Audio, BallTriangle, Bars, CradleLoader, Circles, CirclesWithBar, Grid, Hearts, LineWave, MutatingDots, Oval, Plane, Puff, RevolvingDot, RotatingSquare, Rings, TailSpin, ThreeDots, ThreeCircles, Triangle, Watch };
